export const dogBreeds = [
    'Affenpinscher',
    'Afghan Hound',
    'Airedale Terrier',
    'Akita',
    'Alaskan Malamute',
    'American Staffordshire Terrier',
    'American Water Spaniel',
    'Australian Cattle Dog',
    'Australian Shepherd',
    'Australian Terrier',
    'Basenji',
    'Basset Hound',
    'Beagle',
    'Bearded Collie',
    'Bedlington Terrier',
    'Bernese Mountain Dog',
    'Bichon Frise',
    'Black and Tan Coonhound',
    'Bloodhound',
    'Border Collie',
    'Border Terrier',
    'Borzoi',
    'Boston Terrier',
    'Bouvier Des Flandres',
    'Boxer',
    'Briard',
    'Brittany',
    'Brussels Griffon',
    'Bull Terrier',
    'Bulldog',
    'Bullmastiff',
    'cairn Terrier',
    'Canaan Dog',
    'Chesapeake Bay Retriever',
    'Chihuahua',
    'Chinese Crested',
    'Chinese Shar-Pei',
    'Chow Chow',
    'Clumber Spaniel',
    'Cocker Spaniel',
    'Collie',
    'Curly-coated Retriever',
    'Dachshund',
    'Dalmatian',
    'Doberman Pinscher',
    'English Cocker Spaniel',
    'English Setter',
    'English Springer Spaniel',
    'English Toy Spaniel',
    'Eskimo Dog',
    'Finnish Spitz',
    'Flat-coated Retriever',
    'Fox Terrier',
    'Foxhound',
    'French Bulldog',
    'German Shepherd',
    'German Shorthaired Pointer',
    'German Wirehaired Pointer',
    'Golden Retriever',
    'Gordon Setter',
    'Great Dane',
    'Greyhound',
    'Irish Setter',
    'Irish Water Spaniel',
    'Irish Wolfhound',
    'Jack Russell Terrier',
    'Japanese Spaniel',
    'Keeshond',
    'Kerry Blue Terrier',
    'Komondor',
    'Kuvasz',
    'Labrador Retriever',
    'Lakeland Terrier',
    'Lhasa Apso',
    'Maltese',
    'Manchester Terrier',
    'Mastiff',
    'Mexican Hairless',
    'Newfoundland',
    'Norwegian Elkhound',
    'Norwich Terrier',
    'Otterhound',
    'Papillon',
    'Pekingese',
    'Pointer',
    'Pomeranian',
    'Poodle',
    'Pug',
    'Puli',
    'Rhodesian Ridgeback',
    'Rottweiler',
    'Saint Bernard',
    'Saluki',
    'Samoyed',
    'Schipperke',
    'Schnauzer',
    'Scottish Deerhound',
    'Scottish Terrier',
    'Sealyham Terrier',
    'Shetland sheepdog',
    'Shih Tzu',
    'Siberian Husky',
    'Silky Terrier',
    'Skye Terrier',
    'Staffordshire Bull Terrier',
    'Soft-coated wheaten Terrier',
    'Sussex Spaniel',
    'Spitz',
    'Tibetan Terrier',
    'Vizsla',
    'Weimaraner',
    'Welsh Terrier',
    'West Highland White Terrier',
    'Whippet',
    'Yorkshire Terrier'
]

export const catBreeds = [
    'Abyssinian',
    'Aegean cat',
    'Australian Mist',
    'American Polydactyl',
    'American Bobtail',
    'American Curl',
    'American Longhair',
    'American Shorthair',
    'American Wirehair',
    'Asian Semi-longhair',
    'Balinese',
    'Bengal',
    'Birman',
    'Bombay',
    'Brazilian Shorthair',
    'British Shorthair',
    'British Longhair',
    'Burmese',
    'Burmilla',
    'California Spangled Cat',
    'Chantilly/Tiffany',
    'Chartreux',
    'Chausie',
    'Cheetoh',
    'Colorpoint Shorthair',
    'Cornish Rex',
    'Cymric',
    'Devon Rex',
    'Donskoy or Don Sphynx',
    'Dragon Li',
    'Egyptian Mau',
    'European Shorthair',
    'Exotic Shorthair',
    'German Rex',
    'Havana Brown',
    'Himalayan/Colorpoint Persian',
    'Japanese Bobtail',
    'Javanese',
    'Korat',
    'Kurilian Bobtail',
    'LaPerm',
    'Maine Coon',
    'Manx',
    'Munchkin',
    'Nebelung',
    'Norwegian Forest Cat',
    'Ocicat',
    'Ojos Azules',
    'Oregon Rex',
    'Oriental Bicolour',
    'Oriental Shorthair',
    'Oriental Longhair',
    'Persian',
    'Peterbald',
    'Pixie-bob',
    'Ragamuffin',
    'Ragdoll',
    'Russian Blue',
    'Russian White, Black and Tabby',
    'Savannah',
    'Scottish Fold',
    'Selkirk Rex',
    'Serengeti cat',
    'Siamese',
    'Siberian',
    'Singapura',
    'Snowshoe',
    'Sokoke',
    'Somali',
    'Sphynx',
    'Sumxu',
    'Thai/Old-style Siamese',
    'Tonkinese',
    'Toyger',
    'Turkish Angora',
    'Turkish Van',
    'Turkish Vankedisi',
    'Twisty Cat/Squitten',
    'Ukrainian Levkoy',
    'Ussuri',
    'York Chocolate Cat'
]
